import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Close, Menu } from "../Assets/Icons";
import HeaderLogo from "../Assets/Icons/oc_logo.svg";

const navItems = [
  { label: "Home", to: "/#home" },
  { label: "Challenges", to: "/#industry-reality" },
  { label: "Why Us", to: "/#why-choose-us" },
  { label: "AI", to: "/#how-we-leverage-ai" },
  { label: "Process", to: "/#our-process" },
  { label: "Contact", to: "/#contact-us" },
];

const Header = () => {
  const [active, setActive] = useState(false);

  const linkClass =
    "text-[#8892A4] text-sm font-[400] tracking-wide cursor-pointer transition-all duration-200 ease-in-out hover:text-[#F07023] relative border-t-2 border-t-transparent hover:border-t-[#F07023] pt-1";

  return (
    <header className="navbar fixed top-0 left-0 right-0 z-[550] py-3 px-6 lg:px-10"
      style={{
        backgroundColor: "rgba(8, 12, 16, 0.92)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderTop: "2px solid rgba(240, 112, 35, 0.6)",
        borderBottom: "1px solid #1C2333",
      }}
    >
      <div className="flex justify-between items-center max-w-7xl mx-auto">
        <Link
          to="/"
          className="flex items-center justify-center gap-2 text-[#f07023] text-[calc(0.8vw+12px)]"
        >
          <img src={HeaderLogo} alt="Orangecells" className="h-7 lg:h-8" />
          <span className="font-['Poppins'] tracking-[0.08em]">Orangecells</span>
        </Link>

        <span
          onClick={() => setActive(!active)}
          className="lg:hidden cursor-pointer transition duration-500 text-gray-300 hover:text-[#F07023]"
        >
          {active ? Close : Menu}
        </span>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.label}
              smooth={true}
              duration={500}
              to={item.to}
              className={linkClass}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>

      {active && (
        <div className="lg:hidden mt-4 pt-4 border-t border-[#F07023]/10">
          <nav className="flex flex-col gap-y-5 pb-4">
            {navItems.map((item) => (
              <Link
                key={item.label}
                smooth={true}
                duration={500}
                to={item.to}
                className="text-gray-300 text-sm font-[400] tracking-wide cursor-pointer transition-all duration-300 ease-in-out hover:text-[#F07023]"
                onClick={() => setActive(false)}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
